import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import LegalPageShell from "./LegalPageShell";
import termsEn from "./content/terms.en";
import termsAr from "./content/terms.ar";

export default function TermsOfUse() {
  const { i18n } = useTranslation();
  const T = i18n.language?.startsWith("ar") ? termsAr : termsEn;

  return (
    <LegalPageShell titleKey="legal.termsTitle">
      <section aria-labelledby="tou-intro">
        <h2 id="tou-intro">{T.intro.h2}</h2>
        {T.intro.p1.map((text, i) => (
          <p key={i}>{text}</p>
        ))}
        <p>
          {T.intro.p2.before ? `${T.intro.p2.before} ` : null}
          <Link to="/privacy-policy">{T.intro.p2.privacyLink}</Link>{" "}
          {T.intro.p2.after}
        </p>
      </section>

      <section aria-labelledby="tou-services">
        <h2 id="tou-services">{T.services.h2}</h2>
        <p>{T.services.p1}</p>
      </section>

      <section aria-labelledby="tou-acceptable">
        <h2 id="tou-acceptable">{T.acceptable.h2}</h2>
        <p>{T.acceptable.p1}</p>
        <ul>
          {T.acceptable.items.map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ul>
        <p>{T.acceptable.p2}</p>
      </section>

      <section aria-labelledby="tou-monitoring">
        <h2 id="tou-monitoring">{T.monitoring.h2}</h2>
        <p>{T.monitoring.p1}</p>
      </section>

      <section aria-labelledby="tou-ip">
        <h2 id="tou-ip">{T.ip.h2}</h2>
        <p>{T.ip.p1}</p>
      </section>

      <section aria-labelledby="tou-disclaimer">
        <h2 id="tou-disclaimer">{T.disclaimer.h2}</h2>
        <p>{T.disclaimer.p1}</p>
      </section>

      <section aria-labelledby="tou-liability">
        <h2 id="tou-liability">{T.liability.h2}</h2>
        <p>{T.liability.p1}</p>
        <p>{T.liability.p2}</p>
      </section>

      <section aria-labelledby="tou-indemnity">
        <h2 id="tou-indemnity">{T.indemnity.h2}</h2>
        <p>{T.indemnity.p1}</p>
      </section>

      <section aria-labelledby="tou-law">
        <h2 id="tou-law">{T.law.h2}</h2>
        <p>{T.law.p1}</p>
      </section>

      <section aria-labelledby="tou-changes">
        <h2 id="tou-changes">{T.changes.h2}</h2>
        <p>{T.changes.p1}</p>
      </section>

      <section aria-labelledby="tou-contact">
        <h2 id="tou-contact">{T.contact.h2}</h2>
        <p>
          {T.contact.p1.before}{" "}
          <Link to="/#contact-us">{T.contact.p1.linkLabel}</Link>{" "}
          {T.contact.p1.after}
        </p>
        <address>
          {T.contact.address.map((line, i) => (
            <React.Fragment key={i}>
              {i === 0 ? <strong>{line}</strong> : line}
              {i < T.contact.address.length - 1 ? <br /> : null}
            </React.Fragment>
          ))}
        </address>
      </section>
    </LegalPageShell>
  );
}
